export default "__VITE_ASSET__BiiiIapP__"